import { createSlice } from '@reduxjs/toolkit';

interface SelectedMembershipState extends SubscriptionItem {
  price: {
    id: number;
    amount: number;
    currency: string;
    periodTypeId: number;
    paymentCount: number;
  };
}

interface SubscriptionPurchaseState {
  selectedMembershipGroupId: number | null; // anasayfadan secili grup ile satin almaya gidildiginde kullanilir
  selectedMembershipGroup: any | null;
  selectedMembership: SelectedMembershipState | null;
  selectedPetTypeId: number | null; // sepete ekle butonuna hayvanlari filtrelemek icin kullanilir
}

const initialState: SubscriptionPurchaseState = {
  selectedMembershipGroupId: null,
  selectedMembershipGroup: null,
  selectedMembership: null,
  selectedPetTypeId: null,
};

export const subscriptionPurchaseSlice = createSlice({
  name: 'subscriptionPurchase',
  initialState,
  reducers: {
    setSelectedMembershipGroup: (state, action) => {
      state.selectedMembershipGroup = action.payload;
    },

    setSelectedMembership: (state, action) => {
      state.selectedMembership = action.payload;
    },
    setSelectedMembershipGroupId: (state, action) => {
      state.selectedMembershipGroupId = action.payload;
    },
    setSelectedPetTypeId: (state, action) => {
      state.selectedPetTypeId = action.payload;
    },

    reset: (state) => {
      state.selectedMembershipGroup = null;
      state.selectedMembership = null;
      state.selectedMembershipGroupId = null;
      state.selectedPetTypeId = null;
    },
  },
});

export const {
  setSelectedMembershipGroup,
  setSelectedMembership,
  setSelectedMembershipGroupId,
  setSelectedPetTypeId,
  reset,
} = subscriptionPurchaseSlice.actions;

export default subscriptionPurchaseSlice;

